import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import './purchasedetails.css';
import $ from "jquery";
const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class MaxWidthDialog extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
    data: []
  };

  setItems() {
    let newItems = [];
    let items = this.props.data;
    for (var i = 0; i < items.length; i++) {
      newItems.push({ tax: items[i].tax, total: items[i].total })
    }
    var tax = [];
    var data = [];
    $.each(newItems, function(index, value) {
        if($.inArray(value.tax, tax) == -1)
        {
          tax.push(value.tax);
          data.push(value);
        }
    });
    return data;
  }

  total(tax) {
    console.log("tax="+tax);

    let total = 0;
    let sum = 0;
    let taxs = 0;
    if (this.props.from == 'purchasetaxdetails') {

      this.props.data.map((z)=>{
        if (tax == z.tax) {
          total = ((z.dnp * z.stock) - z.disc);
          taxs = total * (tax/100);
          console.log("taxs="+taxs);
          sum = sum + taxs;
          console.log("sum="+sum);
        }
      })
      return sum/2;
    }
    else {
      this.props.data.map((z)=>{
        if (tax == z.tax) {
          total = z.dnp * z.stock;
          taxs = total * (tax/100);
          sum = sum + taxs;
        }
      });
      return sum/2;
    }
  }

  totals(tax) {
    let total = 0;
    let sum = 0;
    let taxs = 0;
    if (this.props.from == 'purchasetaxdetails') {
      return 0;
    }
    else {
      this.props.data.map((z)=>{
        if (tax == z.tax) {
          total = z.dnp * z.stock;
          taxs = total * (tax/100);
          sum = sum + taxs;
        }
      });
      return sum;
    }
  }

  cgstTotal() {
    let total = 0;
    let taxable = 0;
    let tax = 0;
    if (this.props.from == 'purchasetaxdetails') {
      this.props.data.map((z)=>{
          total = ((z.dnp * z.stock) - z.disc);
          tax = total * (z.tax/100);
          taxable = taxable + tax;
      });
      taxable = taxable.toFixed(2);
      return taxable;
    }
    else {
      this.props.data.map((z)=>{
          total = z.dnp * z.stock;
          tax = total * (z.tax/100);
          taxable = taxable + tax;
      });
      taxable = taxable.toFixed(2);
      return taxable;
    }
  }

  totalCost() {
    if (this.props.from == 'purchasetaxdetails') {
      return 'vinoth';
    }
    else {
      let total = this.cgstTotal() * 2;
      return total;
    }
  }

  totalprice(tax) {
    let total = 0;
    let totals = 0;
    if (this.props.from == 'purchasetaxdetails') {
      this.props.data.map((z) => {
        if (tax == z.tax) {
        totals = (z.dnp * z.stock) - z.disc;
        total = total + totals;
      }
      });
      return total/2;
    }
    else {
      this.props.data.map((z)=>{
        if (tax == z.tax) {
          totals = z.dnp * z.stock;
          total = total + totals;
        }
      });
      return total;
    }
  }

  getTotalAmount() {
    let price = this.props.price;
    if (this.props.from == 'purchasetaxdetails') {
      try {
        price = price.toFixed(2);
      } catch (e) {

      }
      price = Number(price);
      return price;
    }
    else {
      try {
        price = price.toFixed(2);
      } catch (e) {

      }
      price = Number(price).toFixed(2);
      return price;
    }
  }


  render() {
    let data = this.setItems();
    const { classes } = this.props;
    let tax = (<div></div>);
    let x = 0;
    let cgst = data.map((z) => {
      let out = (
        <tr>
          {(x == 0) ? (<th rowspan={data.length}>CGST</th>) : null}
          <td width="(100/x)%">Total: {this.totalprice(z.tax)}</td>
          <td width="(100/x)%">Tax: {z.tax/2}%</td>
          <td width="(100/x)%">
            Rs.  {this.total(z.tax)}
          </td>
          {(x == 0) ? (<th rowspan={data.length} style={{fontSize: 16, color: '#3E71A4'}}>Rs. {this.cgstTotal()/2}</th>) : null}
        </tr>
      );
      x++;
      return out;
    });
    x  = 0;
    let sgst = data.map((z) => {
      let out = (
        <tr>
          {(x == 0) ? (<th rowspan={data.length}>SGST</th>) : null}
          <td width="(100/x)%">Total: {this.totalprice(z.tax)}</td>
          <td width="(100/x)%">Tax: {z.tax/2}%</td>
          <td width="(100/x)%">
            Rs.  {this.total(z.tax).toFixed(2)}
          </td>
          {(x == 0) ? (<th rowspan={data.length} style={{fontSize: 16, color: '#3E71A4'}}>Rs. {this.cgstTotal()/2}</th>) : null}
        </tr>
      );
      x++;
      return out;
    });
    x  = 0;
    let igst = data.map((z) => {
      let out = (
        <tr>
          {(x == 0) ? (<th rowspan={data.length}>IGST</th>) : null}
          <td width="(100/x)%">Total: {this.totalprice(z.tax).toFixed(2)}</td>
          <td width="(100/x)%">Tax: {z.tax}%</td>
          <td width="(100/x)%">
            Rs.  {this.totals(z.tax).toFixed(2)}
          </td>
          {(x == 0) ? (<th rowspan={data.length} style={{fontSize: 16, color: '#3E71A4'}}>Rs. {this.cgstTotal()}</th>) : null}
        </tr>
      );
      x++;
      return out;
    });
    if (this.props.branchState == this.props.purchaseState) {
      tax = (
        <table id="table" width="100%">
          <tbody>{cgst}</tbody>
          <tbody>{sgst}</tbody>
          <tbody>
          <tr>
            <th colspan="3" style={{fontSize: 16}}>(CGST + SGST + TOTAL)</th>
            <th colspan="2" style={{color: '#3E71A4', fontSize: 16}}>Rs. {this.getTotalAmount()}</th>
          </tr>
          </tbody>
        </table>

      )
    }
    else {
      tax = (
        <table id="table" width="100%">
          <tbody>{igst}</tbody>
          <tbody>
          <tr>
            <th colspan="3" style={{fontSize: 16}}>(IGST + TOTAL)</th>
            <th colspan="2" style={{color: '#3E71A4', fontSize: 16}}>Rs. {this.getTotalAmount()}</th>
          </tr>
          </tbody>
        </table>
      )
    }
    return (
      <div>
        {tax}
      </div>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);
